export default "__VITE_ASSET__BaVK3ymS__"